import { Component, OnInit, inject } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { RouterLink } from '@angular/router';
import { NgClass, NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { AuthService } from '../../../services/auth/auth.service';

import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { ForgotPasswordRequest } from '../../../interfaces/auth/forgot-password.model';

enum ErrorStates {
  NotSubmitted,
  HasError,
  NoError,
}

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    NgTemplateOutlet,
    RouterLink,
    AsyncPipe,
    InputTextModule,
    ButtonModule,
  ],
})
export class ForgotPasswordComponent implements OnInit {
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);

  forgotPasswordForm!: FormGroup;
  errorState: ErrorStates = ErrorStates.NotSubmitted;
  errorStates = ErrorStates;
  isLoading$: Observable<boolean>;

  // private fields
  private unsubscribe: Subscription[] = [];
  constructor() {
    this.isLoading$ = this.authService.isLoading$;
  }

  ngOnInit(): void {
    this.initForm();
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.forgotPasswordForm.controls;
  }

  initForm() {
    this.forgotPasswordForm = this.fb.group({
      email: [
        '',
        Validators.compose([
          Validators.required,
          Validators.email,
          Validators.minLength(3),
          Validators.maxLength(320),
        ]),
      ],
    });
  }

  submit() {
    this.errorState = ErrorStates.NotSubmitted;
    const forgotPasswordModel: ForgotPasswordRequest = {
      email: this.f['email'].value,
      resetUrl: `${document.location.origin}/auth/reset-password`,
    };
    const forgotPasswordSubscr = this.authService
      .forgotPassword(forgotPasswordModel)
      .pipe(first())
      .subscribe({
        next: () => {
          this.errorState = ErrorStates.NoError;
        },
        error: () => {
          this.errorState = ErrorStates.HasError;
        },
      });
    this.unsubscribe.push(forgotPasswordSubscr);
  }
}
